import React, { DetailedHTMLProps, ImgHTMLAttributes } from "react";
import styles from "./designer-or-store-logo.module.css";

export interface DesignerOrStoreLogoProps
    extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
    name: string;
    alt: string;
}

export function DesignerOrStoreLogo({
    src,
    alt,
    name,
    ...props
}: DesignerOrStoreLogoProps): JSX.Element {
    return src ? (
        <img src={src} alt={alt} {...props} />
    ) : (
        <div className={styles.noLogoWrapper}>
            <p aria-label={alt}>{name[0]}</p>
        </div>
    );
}
